"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingField = exports.SortingDirection = void 0;
var SortingDirection;
(function (SortingDirection) {
    SortingDirection[SortingDirection["ASC"] = 0] = "ASC";
    SortingDirection[SortingDirection["DESC"] = 1] = "DESC";
})(SortingDirection = exports.SortingDirection || (exports.SortingDirection = {}));
var SortingField;
(function (SortingField) {
    SortingField["itemName"] = "ITEM_NAME";
    SortingField["price"] = "PRICE";
    SortingField["stock"] = "STOCK";
})(SortingField = exports.SortingField || (exports.SortingField = {}));
//# sourceMappingURL=sorting.js.map